<template>
  <div class="media-container scrollbar" v-loading="mediaLoading">
    <div class="form-dark media-body">
      <h4 class="media-title">{{$t('media.摄像头')}}</h4>
      <div class="error_message">{{ message }}</div>
      <div class="media-select-group">
        <div>
          <el-select
            v-model="VideoInputDeviceId"
            class="media-select"
            popper-class="tip-select"
            :popper-append-to-body="false"
            :loading="loading"
          >
            <el-option
              @click.native="changeVideoOrAudioTrack('video', item.deviceId)"
              v-for="item in VideoInputList"
              :key="item.deviceId"
              :label="item.label"
              :value="item.deviceId"
            >
            </el-option>
          </el-select>
        </div>
        <div style="width: 120px">
          <el-select
            :value="mediaQuality"
            class="media-select"
            popper-class="tip-select"
            :popper-append-to-body="false"
            :loading="loading"
            @change="mediaQualityChange"
          >
            <el-option
              v-for="item in mediaQualityList"
              :key="item.label"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </div>
        <!-- <div style="width: 120px;">
          <el-select
            v-model="mediaPicQuality"
            class="media-select"
            popper-class="tip-select"
            :popper-append-to-body="false"
            :loading="loading"
            @change="mediaPicQualityChange"
          >
            <el-option
              v-for="item in mediaPicQualityList"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div> -->
        <!-- <div>
          <el-tooltip popper-class="mediaSelectTip" effect="dark" placement="top" offset="40" :content="$t('setting.mediaSelectTip')">
            <img class="tip-icon" style="margin-left: 0;" :src="require('@/svg/tip.svg')" />
          </el-tooltip>
        </div> -->
      </div>
      <video
        id="localVideo"
        class="media-video"
        muted
        autoplay
        width="240"
        height="134"
        v-show="VideoInputDeviceId || curSelectVideoInputId"
      ></video>
      <div
        v-show="!(VideoInputDeviceId || curSelectVideoInputId)"
        class="check-nocamera"
      >
        <img :src="nocamera" />
      </div>
    </div>
    <div class="form-dark media-body">
      <h4 class="media-title">{{$t('media.麦克风')}}</h4>
      <el-select
        v-model="AudioInputDeviceId"
        class="media-select"
        popper-class="tip-select"
        :popper-append-to-body="false"
      >
        <el-option
          @click.native="changeVideoOrAudioTrack('audio', item.deviceId)"
          v-for="item in AudioInputList"
          :key="item.label"
          :label="item.label"
          :value="item.deviceId"
        >
        </el-option>
      </el-select>
      <!-- 进度条 -->
      <ul class="check-process">
        <li
          v-for="(p, i) in processList"
          :key="i"
          :class="{ 'check-process-active': !!p }"
        ></li>
      </ul>
    </div>
    <div class="form-dark media-body">
      <h4 class="media-title">{{$t('media.扬声器')}}</h4>
      <div id="audioOutput">
        <el-select
          ref="outPutSelect"
          v-model="AudioOutPutDeviceId"
          class="media-select"
          popper-class="tip-select"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in AudioOutPutList"
            :key="item.deviceId"
            :label="item.label"
            :value="item.deviceId"
            @click.native="setAudioDevice(item.deviceId)"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          style="margin-left: 10px"
          v-if="!isPlaying"
          @click="changeAudioDestination"
          >{{$t('media.测试音频')}}</el-button
        >
        <el-button
          v-else
          @click="stopTest"
          type="primary"
          style="margin-left: 10px"
          >{{$t('media.停止检测')}}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/components/doc/bus";
import { Tooltip } from "element-ui";
import mediaError from "@/mixins/mediaError";
import { mapGetters } from "vuex";
export default {
  name: "media",
  components: {
    [Tooltip.name]: Tooltip,
  },
  mixins: [mediaError],
  data() {
    return {
      AudioInputList: [],
      AudioOutPutList: [],
      VideoInputList: [],
      AudioInputDeviceId: null,
      AudioOutPutDeviceId: null,
      VideoInputDeviceId: null, //之前选择的视频设备id
      curSelectAudioInputId: null,
      curSelectVideoInputId: null, //当前选择的视频设备id
      processList: [],
      inputInstant: null,
      mic: null,
      context: null,
      script: null,
      audioPlaySrc: require("@/file/audio.mp3"),
      audioEl: null,
      isPlaying: false,
      canInitMedia: false,
      mediaQuality: null,
      mediaQualityList: [
        {
          label: "1920*1080",
          value: 1920,
          height: 1080,
        },
        {
          label: "1280*720",
          value: 1280,
          height: 720,
        },
        {
          label: "640*360",
          value: 640,
          height: 360,
        },
      ],
      mediaPicQuality: 1,
      mediaPicQualityList: [
        {
          label: this.$t('media.画质优先'),
          value: 1,
        },
        {
          label: this.$t('media.流畅优先'),
          value: 2,
        },
      ],
      pubUpdateTimer: undefined,
      loading: false,
      mediaLoading: false,
    };
  },
  computed: {
    ...mapGetters(["cameraResolution"]),
    ischangeVideo () {
      return this.$store.getters.ischangeVideo;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    publishStream() {
      let pubStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream
      ) {
        pubStream = this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream;
      }
      return pubStream;
    },
    publication() {
      let pubLocallication = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publication
      ) {
        pubLocallication =
          this.rtcClient.RTCRoom.webrtc.publishLocal.publication;
      }
      return pubLocallication;
    },
    createVideoorAudioStream() {
      let createStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.createVideoorAudioStream
      ) {
        createStream = this.rtcClient.RTCRoom.webrtc.createVideoorAudioStream;
      }
      return createStream;
    },
    changeDevice() {
      let chaneDeviceFun = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.changeDevice
      ) {
        chaneDeviceFun = this.rtcClient.RTCRoom.webrtc.changeDevice;
      }
      return chaneDeviceFun;
    },
    publishLocalStream() {
      let pubLocalStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocalStream
      ) {
        pubLocalStream = this.rtcClient.RTCRoom.webrtc.publishLocalStream;
      }
      return pubLocalStream;
    },
    hasStreamAndCanInit() {
      return this.canInitMedia && this.publishStream;
    },
    getCameraResolution(){
      return this.cameraResolution == 1080 ? {  width: 1920,height: 1080} : this.cameraResolution == 360 ?  {width: 640,  height: 360}: {width: 1280,  height: 720}
    },
    audioInputDeviceId() {
      return this.$store.getters.AudioInputDeviceId;
    },
    videoInputDeviceIds() {
      return this.$store.getters.VideoInputDeviceId;
    },
    audioOutputDeviceId() {
      return this.$store.getters.AudioOutputDeviceId;
    },

  },
  watch: {
    publishStream: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (val && !old) {
          this.pubUpdateTimer && clearTimeout(this.pubUpdateTimer);
          this.pubUpdateTimer = setTimeout(() => {
            this.init();
            this.calcMaxRatio();
          }, 500);
        }
      },
    },
    audioInputDeviceId: {
      immediate: true,
      handler(val) {
        this.AudioInputDeviceId = val
        this.curSelectAudioInputId = val
      }
    },
    audioOutputDeviceId: {
      immediate: true,
      handler(val) {
        this.AudioOutPutDeviceId = val
      }
    },
    videoInputDeviceIds: {
      immediate: true,
      handler(val) {
        this.VideoInputDeviceId = val
        this.curSelectVideoInputId = val
        this.calcMaxRatio();
      }
    },
    hasStreamAndCanInit(val, old) {
      if (val && !old) {
        this.init();
      }
    },
  },
  beforeDestroy() {
    this.stopAudioContext();
  },
  created() {
    this.addEvent();
  },
  mounted() {
    this.mediaPicQuality =(sessionStorage.getItem("mediaSelectPicQuality") || 1) >> 0;
    Bus.$on('ondevicechange3', () => {
      console.log('ondevicechange media')
      if (this.ischangeVideo && this.isSafari()) {
        this.$store.commit("SET_ISCHANGEVIDEO", false);
        return
      }
      this.init();
    });
    this.init();
    this.scrollHideSelect();
  },
  methods: {
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
    },
    // fixed: #50502 主播端音视频设置扬声器下拉框滚动窗破裂
    scrollHideSelect() {
      var scrollEl = document.querySelector(".media-container");
      var outEl = document.getElementById("audioOutput");
      document.querySelector(".media-container").addEventListener("scroll", () => {
          if (outEl.offsetTop + scrollEl.scrollTop > scrollEl.offsetHeight) {
            this.$refs.outPutSelect.blur();
          }
        });
    },
    addEvent() {
      Bus.$on("stopMic", () => {
        this.stopAudioContext();
        this.stopAudioDestination();
      });
      Bus.$on("initMedia", () => {
        this.canInitMedia = true;
        this.getProcess();
      });
    },
    async init() {
      console.log("init media");
      this.processList = [];
      let deviceInfos = await navigator.mediaDevices.enumerateDevices();
      console.log(deviceInfos, "设备列表media");
      this.VideoInputList = deviceInfos.filter((d) => {
        return d.kind === "videoinput";
      });
      this.AudioInputList = deviceInfos.filter((d) => {
        return d.kind === "audioinput";
      });
      this.AudioOutPutList = deviceInfos.filter((d) => {
        return d.kind === "audiooutput";
      });
      let audioInputFlag = this.AudioInputList.find(item => item.deviceId == this.audioInputDeviceId)
      let audioOutFlag = this.AudioOutPutList.find(item => item.deviceId == this.audioOutputDeviceId)
      let videoFlag = this.VideoInputList.find(item => item.deviceId == this.videoInputDeviceIds)

      this.VideoInputDeviceId = null;
      this.AudioInputDeviceId = null;
      // 如果有发布流
      if (this.publishStream) {
        if (this.publishStream.getVideoTracks()[0] != undefined) {
          if (document.getElementById("localVideo")) {
            document.getElementById("localVideo").srcObject = this.publishStream;
          }
          if (this.videoInputDeviceIds && videoFlag) {
            this.VideoInputDeviceId = this.videoInputDeviceIds;
          } else {
            this.VideoInputDeviceId = this.publishStream.getVideoTracks()[0].getSettings().deviceId;
          }
          //根据媒体信息返回当前选择的分辨率
          this.mediaQuality = this.publishStream.getVideoTracks()[0].getSettings().width
        } else {
          if (document.getElementById("localVideo")) {
            document.getElementById("localVideo").srcObject = null;
          }
        }
        if ( this.audioInputDeviceId && audioInputFlag) {
          this.AudioInputDeviceId = this.audioInputDeviceId
          this.curSelectAudioInputId = JSON.parse(JSON.stringify(this.AudioInputDeviceId));
          this.getProcess();
        }  else if (this.publishStream.getAudioTracks()[0]) {
          this.AudioInputDeviceId = this.publishStream.getAudioTracks()[0].getSettings().deviceId;
          this.curSelectAudioInputId = JSON.parse(JSON.stringify(this.AudioInputDeviceId));
          this.getProcess();
        }
      } else {
        this.AudioInputDeviceId = this.AudioInputList[0].deviceId;
        this.VideoInputDeviceId = this.VideoInputList[0].deviceId;
      }
      if (this.audioOutputDeviceId && audioOutFlag) {
        this.AudioOutPutDeviceId = this.audioOutputDeviceId
      } else if ( (document.getElementById("live") && document.getElementById("live").sinkId && this.AudioOutPutList.length)) {
        let audioOutFlag2 = this.AudioOutPutList.find(item => item.deviceId ==  document.getElementById("live").sinkId)
        if (audioOutFlag2) {
          this.AudioOutPutDeviceId = document.getElementById("live").sinkId;
        } else {
          this.AudioOutPutDeviceId = 'default'
          this.setAudioDevice('default')
        }
      } else {
        this.AudioOutPutDeviceId = 'default'
        this.setAudioDevice('default')
      }
      this.$store.commit("SET_AUDIOOUTPUTDEVICEID", this.AudioOutPutDeviceId);
      this.$store.commit('SET_AUDIOINPUTDEVICEID', this.AudioInputDeviceId);
      this.$store.commit("SET_VIDEOINPUTDEVICEID", this.VideoInputDeviceId);
      for (let i = 0; i < 20; i++) {
        this.processList.push(false);
      }
    },
    async getProcess() {
      await this.$nextTick();
      if (!(this.publishStream instanceof MediaStream)) return;
      try {
        this.stopAudioContext();
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        this.context = new AudioContext();
        this.mic = this.context.createMediaStreamSource(this.publishStream);
        this.script = this.context.createScriptProcessor(2048, 1, 1);
        this.mic.connect(this.script);
        this.script.connect(this.context.destination);
        this.script.onaudioprocess = (event) => {
          const input = event.inputBuffer.getChannelData(0);
          let inputsum = 0.0;
          for (let i = 0; i < input.length; ++i) {
            inputsum += input[i] * input[i] * 5;
          }
          this.inputInstant = parseInt(
            Math.sqrt(inputsum / input.length) * 100
          );
          this.setProcessList();
        };
      } catch (error) {
        console.error(error);
      }
    },
    setProcessList() {
      let isActive = parseInt(this.inputInstant / 5);
      this.processList = [];
      for (let i = 0; i < 20; i++) {
        if (i < isActive) {
          this.processList.push(true);
        } else {
          this.processList.push(false);
        }
      }
    },
    stopAudioContext() {
      if (this.mic) {
        this.mic.disconnect();
        this.mic = null;
      }
      if (this.script) {
        this.script.disconnect();
        this.script = null;
      }
    },
    async calcMaxRatio() {
      // console.error('calcMaxRatio')
      let videoTrack = this.publishStream && this.publishStream.getVideoTracks()[0];
      if (!videoTrack) return;
      // console.error('calcMaxRatio2')
      let videoTrackSettings = videoTrack.getSettings(),
        videoTrackCapabilities = videoTrack.getCapabilities
          ? videoTrack.getCapabilities()
          : null;
      if (!videoTrackCapabilities) {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: {
              width: 1920,
              height: 1080,
            },
          });
          videoTrackSettings = stream.getVideoTracks()[0].getSettings();
          stream.getTracks().forEach((v) => v.stop());
        } catch (error) {
          console.log(error);
        }
      }
      let videoMaxResolution = videoTrackCapabilities
        ? videoTrackCapabilities.width.max
        : videoTrackSettings
        ? videoTrackSettings.width
        : null;
      let constraints = {
        width: 1920,
        height: 1080,
      };
      this.mediaQualityList.forEach((val) => {
        if (videoMaxResolution < val.value) {
          val.disabled = true;
        } else {
          val.disabled = false;
        }
      });
      const quality = this.mediaQualityList.find((v) => !v.disabled);
      if (quality) {
        constraints = {
          width: quality.value,
          height: quality.height,
        };
      }
      const preConstraints = JSON.parse(
        sessionStorage.getItem("mediaSelectConstraints")
      ) || this.getCameraResolution || {};
      if (preConstraints && preConstraints.width <= constraints.width) {
        constraints = preConstraints;
      }
      this.execQuality(constraints);
    },
    // 更新分辨率
    mediaQualityChange(data) {
      const val = this.mediaQualityList.find((v) => v.value === data);
      const constraints = {
        width: val.value,
        height: val.height,
      };
      this.execQuality(constraints);
    },
    async execQuality(constraints) {
      const preQuality = this.mediaQuality;
      this.mediaQuality = constraints.width;
      this.loading = true;
      try {
        await this.rtcClient.RTCRoom.webrtc.setApplyConstraints(
          this.publishStream,
          constraints
        );
        sessionStorage.setItem(
          "mediaSelectConstraints",
          JSON.stringify(constraints)
        );
        this.setSendMaxBitrate(constraints.width);
      } catch (error) {
        this.$message.error(this.$t('media.分辨率设置失败'));
        console.log(error);
        this.mediaQuality = preQuality;
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    // 更新画质
    mediaPicQualityChange(data) {
      sessionStorage.setItem("mediaSelectPicQuality", data);
      Bus.$emit("mediaSelectPicQuality", data);
      this.setQualityType(data);
    },
    setSendMaxBitrate(value) {
      const maxBitrate =
        value == 1920 ? 2000000 : value == 1280 ? 1500000 : 600000;
      console.log(maxBitrate);
      if (!this.publication) return;
      this.publication.getSenders().forEach(async (sender) => {
        if (sender.track.kind == "video") {
          const params = sender.getParameters();
          params.encodings.forEach((encoding) => {
            encoding.maxBitrate = maxBitrate;
            encoding.maxFramerate = 30;
          });
          await sender.setParameters(params);
        }
      });
    },
    setQualityType(data) {
      if (!this.publication) return;
      this.publication.getSenders().forEach(async (sender) => {
        if (sender.track.kind == "video") {
          const params = sender.getParameters();
          params.degradationPreference =
            data === 1 ? "maintain-resolution" : "maintain-framerate";
          sender.setParameters(params);
        }
      });
    },
    setAudioDevice(value) {
      this.AudioOutPutDeviceId = value;
      // document.getElementById("local").setSinkId(value);
      if (document.getElementById("live")) {
        document.getElementById("live").setSinkId(value);
      }
      this.$store.commit("SET_AUDIOOUTPUTDEVICEID", this.AudioOutPutDeviceId);
      this.stopAudioDestination();
    },
    changeAudioDestination() {
      this.stopAudioDestination();
      if (!this.audioEl) {
        this.audioEl = new Audio();
      }
      if (this.AudioOutPutDeviceId != -1) {
        this.audioEl.src = this.audioPlaySrc;
        console.log(this.AudioOutPutDeviceId);
        this.audioEl.setSinkId(this.AudioOutPutDeviceId);
        this.audioEl.volume = (50 / 100).toFixed(1);
      }
      this.audioEl.onended = () => {
        this.isPlaying = false;
        console.log("播放结束");
      };
      this.audioEl.play();
      this.isPlaying = true;
    },
    // 停止检测扬声器
    stopTest() {
      this.stopAudioDestination();
    },
    stopAudioDestination() {
      this.isPlaying = false;
      if (this.audioEl) {
        this.audioEl.pause();
        this.audioEl = null;
      }
    },
    async changeVideoOrAudioTrack(type, DeviceId) {
      var deviceInfo = null;
      this.mediaLoading = true;
      if (type == "video") {
        this.loading = true;
        // if (this.curSelectVideoInputId == DeviceId) return;
        deviceInfo = { cameraDeviceId: DeviceId };
        this.$store.commit("SET_ISCHANGEVIDEO", true);
      } else {
        // if (this.curSelectAudioInputId == DeviceId) return;
        deviceInfo = { micDeviceId: DeviceId };
      }
      try {
        let replaceTrackInfo = await this.replaceTrack(
          deviceInfo,
          type,
          "changeDevice"
        );
        console.log(replaceTrackInfo, "replaceTrackInfo");
        if (
          replaceTrackInfo &&
          replaceTrackInfo.code &&
          replaceTrackInfo.code == 1
        ) {
          // 获取摄像头错误信息
          console.log(replaceTrackInfo, "error");

          this.getUserMediaError(replaceTrackInfo.info.name);
          this.mediaLoading = false;
        } else {
          console.log(replaceTrackInfo, "success");
          this.getUserMediaError("success");
          if (type == "video") {
            this.curSelectVideoInputId = DeviceId;
            document.getElementById("localVideo").srcObject =  this.publishStream;
            this.$store.commit("SET_VIDEOINPUTDEVICEID", this.curSelectVideoInputId);

            // this.calcMaxRatio();
           this.mediaLoading = false;
          } else {
            this.curSelectAudioInputId = DeviceId;
            this.$store.commit('SET_AUDIOINPUTDEVICEID', this.curSelectAudioInputId);
            this.getProcess();
           this.mediaLoading = false;
          }
        }
      } catch (error) {
        console.log(error);
       this.mediaLoading = false;
      } finally {
        this.loading = false;
        this.mediaLoading = false;
      }
    },
    async replaceTrack(deviceInfo, type, status) {
      var isExitVideoOrAudio = false;
      if (
        this.publishStream &&
        this.publishStream.getVideoTracks()[0] &&
        this.publishStream.getAudioTracks()[0]
      ) {
        isExitVideoOrAudio = true;
      }
      var deviceId =
        type == "video" ? deviceInfo.cameraDeviceId : deviceInfo.micDeviceId;
      console.log(this.rtcClient.RTCRoom.webrtc);
      console.log(deviceId);
      console.log(type);
      var publishStream = await this.rtcClient.RTCRoom.webrtc
        .createVideoorAudioStream(deviceId, type, status)
        .catch((err) => {
          this.loading = false;
          return err;
        });
      console.log(publishStream);
      if (publishStream && publishStream.code == 1) return publishStream;
      if (isExitVideoOrAudio) {
        this.changeDevice(this.publication, this.publishStream);
        if (type == "video") {
          this.publishAfter(0, this.publication);
        }
        type == "video"
          ? Bus.$emit("addVideoTrackEvent")
          : Bus.$emit("addAudioTrackEvent");
      } else {
        if (this.publication) {
          this.publication
            .stop()
            .then(async () => {
              let publishMsg = await this.rtcClient.RTCRoom.webrtc
                .publishLocalStream(
                  {
                    VideoInputDeviceId: this.videoInputDeviceId,
                    AudioInputDeviceId: this.AudioInputDeviceId,
                  },
                  {
                    video: {
                      deviceId: this.videoInputDeviceId,
                    },
                  },
                  {video: {enabled: false}}
                )
                .catch((err) => {
                  this.loading = false;
                  return err;
                });
              if (publishMsg.code == 0) {
                this.publishAfter(0, publishMsg.data);
              }
              type == "video"
                ? Bus.$emit("addVideoTrackEvent")
                : Bus.$emit("addAudioTrackEvent");
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          let publishMsg = await this.rtcClient.RTCRoom.webrtc
            .publishLocalStream(
              {
                VideoInputDeviceId: this.videoInputDeviceId,
                AudioInputDeviceId: this.AudioInputDeviceId,
              },
              {
                video: {
                  deviceId: this.videoInputDeviceId,
                },
              },
              {video: {enabled: false}}
            )
            .catch((err) => {
              this.loading = false;
              return err;
            });
          if (publishMsg.code == 0) {
            this.publishAfter(0, publishMsg.data);
          }
          type == "video"
            ? Bus.$emit("addVideoTrackEvent")
            : Bus.$emit("addAudioTrackEvent");
        }
      }

      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    publishAfter() {},
  },
};
</script>

<style  lang="scss" scoped>
.media-container {
  background-color: #2d304f;
  height: 432px;
  overflow-y: scroll;
  .media-body {
    text-align: left;
    margin: 0px 30px;
    .media-select {
      margin: 10px 0px;
    }
    .media-title {
      height: 70px;

      border-bottom: 1px solid #424967;
      line-height: 70px;
    }
    .media-video {
      display: block;
    }
  }
  .check-process {
    width: 240px;
    display: flex;
    justify-content: space-around;
    margin: 0px;
    li {
      display: inline-block;
      width: 6px;
      height: 16px;
      border-radius: 3px;
      background-color: $purple-color;
    }
    .check-process-active {
      background-color: $green-color !important;
    }
    .check-speaker-btn {
      margin-left: 10px;
    }
  }
}
::v-deep .el-loading-mask{
  background-color: rgba(45,48,79,0);
}

.media-select-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.error_message {
  margin-top: 10px;
  margin-bottom: 0;
}
.check-nocamera {
  text-align: center;
  vertical-align: middle;
  margin: 0;
}
</style>
